import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { publicUnsubscribeVacancy } from "@/lib/api/vacancy-sources.functions";

export const Route = createFileRoute("/careers/unsubscribe")({
  validateSearch: (s: Record<string, unknown>) => ({ token: String(s.token ?? "") }),
  head: () => ({
    meta: [
      { title: "Unsubscribe — Vacancy alerts" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: UnsubPage,
});

function UnsubPage() {
  const { token } = useSearch({ from: "/careers/unsubscribe" });
  const fn = useServerFn(publicUnsubscribeVacancy);
  const [state, setState] = useState<"loading" | "ok" | "invalid">("loading");

  useEffect(() => {
    if (!token) {
      setState("invalid");
      return;
    }
    fn({ data: { token } })
      .then((r: any) => setState(r.ok ? "ok" : "invalid"))
      .catch(() => setState("invalid"));
  }, [token]);

  return (
    <div className="container-narrow py-16 text-center">
      {state === "loading" && <p>Unsubscribing…</p>}
      {state === "ok" && (
        <>
          <h1 className="font-display text-2xl text-navy">Unsubscribed</h1>
          <p className="mt-2 text-muted-foreground">
            You will no longer receive vacancy alerts. Subscribe again anytime from the careers page.
          </p>
        </>
      )}
      {state === "invalid" && (
        <>
          <h1 className="font-display text-2xl text-navy">Invalid link</h1>
          <p className="mt-2 text-muted-foreground">This unsubscribe link is not valid.</p>
        </>
      )}
    </div>
  );
}
